<circle cx="25" cy="25" r="24" fill="currentColor" />
